import { coaches } from './coaches'

export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar: string
}

/**
 * SAMPLE COPY — draft quotes written in the buyer's own language (VOC) to
 * show the angle each review should cover. Replace every quote with a real,
 * verifiable buyer review before launch (FTC + Meta ad review).
 */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      '[Sample] Sunday nights used to be three hours of programming. Now I find today’s session, print it and go teach. That alone paid for it the first week.',
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
  {
    quote:
      '[Sample] I had two big workout bundles sitting in my downloads. The problem was never workouts — it was picking one at 5 a.m. This just tells me.',
    author: coaches[1].name,
    role: coaches[1].role,
    avatar: coaches[1].avatar,
  },
  {
    quote:
      '[Sample] The Adaptation Matrix is the part I use most. Rain, no kettlebells, a brand-new client — I swap the movement, keep the clock, and the class runs.',
    author: coaches[2].name,
    role: coaches[2].role,
    avatar: coaches[2].avatar,
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      '[Sample] The class scripts and the cue library changed my classes. I finally know exactly what to say in the demo and when the room starts to fade.',
    author: coaches[3].name,
    role: coaches[3].role,
    avatar: coaches[3].avatar,
  },
  {
    quote:
      '[Sample] Mixed levels were my biggest headache. Beginner, Regular and Advanced on the same page, same clock, and nobody gets left standing around.',
    author: coaches[4].name,
    role: coaches[4].role,
    avatar: coaches[4].avatar,
  },
  {
    quote:
      '[Sample] I bought it for the calendar and stayed for the retention systems. Telling clients we re-test Week 1 in Week 52 keeps them showing up.',
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
]
